import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Link } from "react-router-dom";
import { Breadcrumb, Spin, Card, Row, Col, Alert } from 'antd';
import { Product } from "../../../models";
import PageHeaderLayout from '../../../layouts/PageHeaderLayout';
import { RemoveForm } from '../../../components/';
import styles from './index.less';

const mapStateToProps = state => ({
  currentProduct: state.product.current,
  categories: state.global.categories,
});
class ProductRemove extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
    };
  }

  componentDidMount() {
    this.setLoadingFalse();
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.match.params.id && !nextProps.match.params.id) {
      this.props.formReset();
      this.setState({ loading: true }, () => this.setLoadingFalse());
    }
  }

  setLoadingFalse = () => {
    setTimeout(() => {
      this.setState({ loading: false });
    }, 300);
  }

  loading = () => (
    <div className={styles.loading}>
      <Spin />
    </div>
  )

  render() {
    const { currentProduct } = this.props;
    const breadcrumb = (
      <div className={styles.pageTop}>
        <Breadcrumb className={styles.Topbread}>
          <Breadcrumb.Item><Link to="/">Нүүр</Link></Breadcrumb.Item>
          <Breadcrumb.Item><Link to="/products">Бараа</Link></Breadcrumb.Item>
          <Breadcrumb.Item>Бараа устгах</Breadcrumb.Item>
        </Breadcrumb>
      </div>);


    const form = {
      schema: {
        title: 'Form',
        type: 'object',
        required: ['relation_id', 'description', 'price'],
        column: 12,
        properties: {
        },
      },
      uiSchema: {
      },
    };

    return (

      <PageHeaderLayout
        content={breadcrumb}
      >
        {
            this.state.loading ?
            this.loading() :
            <Card bordered={false} >
              <Row>
                <Col span={24} className={styles.formCol}>

                  {this.props.currentProduct.error ?
                    <Alert
                      message="Алдаа"
                      description="Алдаа гарлаа."
                      type="error"
                      showIcon
                    /> : null
                  }
                  <Row>
                    <Col span={12} offset={6}>
                      <Alert
                        message="Анхаар"
                        description={`Tа яг одоо " ${currentProduct.data.title} " барааг устгах гэж байна.`}
                        type="warning"
                        showIcon
                      />
                    </Col>
                  </Row>
                  <RemoveForm
                    form={form}
                    data={this.props.currentProduct.data}
                    fetchData={this.props.match.params.id ? this.props.productDetail : undefined}
                    dataParams={{ body: { id: this.props.match.params.id } }}
                    delete={this.props.productDelete}
                    onSubmit={this.handleSubmit}
                  />
                </Col>
              </Row>
            </Card>
          }
      </PageHeaderLayout>
    );
  }
}

ProductRemove.propTypes = {
  match: PropTypes.object.isRequired,
  productDetail: PropTypes.func.isRequired,
  productDelete: PropTypes.func,
  formReset: PropTypes.func.isRequired,
  currentProduct: PropTypes.object,
};

ProductRemove.defaultProps = {
  currentProduct: undefined,
  productDelete: undefined,
};


export default connect(mapStateToProps, {
  formReset: Product.reset,
  productDetail: Product.get,
  productDelete: Product.delete,
})(ProductRemove);



// WEBPACK FOOTER //
// ./src/containers/Products/Remove/index.js